<template lang="pug">
.wrapper
  .vue-time-entries-collisions(v-if="editingWithoutCollisions")
    .table-wrapper.collisions-alert-table
      table.table
        thead
          tr
            th.editing-without-collisions
              .hi.hi-important.hi-16.mr-5
            th
              span.is-regular {{ editingWithoutCollisionsMessage }}
  .vue-time-entries-collisions(v-if="collisionsExists || notAccessibleExists")
    .table-wrapper.collisions-alert-table
      table.table
        thead
          tr
            th.d-flex
              .hi.hi-important.hi-16.mr-5
            th.collision-warning-message
              span {{ collisionWarningMessage }}
    .table-wrapper(v-if="collisionsExists || notAccessibleExists")
      .scrollable
        table.table
          thead
            tr
              th
              th Time entry
              th.text-right Duration
              th
          tbody
            tr(
              v-for="(collision, index) in check.collisions"
              :key="`${collisionText(collision)}-${index}`"
            )
              td
              td
                | {{ collisionText(collision) }}
                i.fa.fa-question-circle.a-tooltip(
                  v-tooltip="true"
                  :title="collision.task_summary || collisionTooltip"
                )

              td.text-right {{ formatDuration(collision.tracked) }}
              td
                span.fa.fa-exclamation-triangle.text-error(
                  v-show="collision.immutable"
                  v-tooltip="true"
                  :title="'Contains locked time'"
                )
            tr.not_accessible(
              v-for="(not_accessible, index) in check.not_accessible"
              :key="`${not_accessible.project_name}-${index}`"
            )
              td
              td {{ not_accessible.project_name }}
              td.text-right {{ formatDuration(not_accessible.tracked) }}
              td
                span.fa.fa-exclamation-triangle.text-error(title="Time not accessible due to permissions")
</template>
<script>
import { isEmpty } from 'lodash-es';
import { mapGetters } from 'vuex';
import { getTaskFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'TimeEntriesCollisions',
  props: {
    check: Object,
    isWorkBreak: {
      type: Boolean,
      default: false,
    },
    isManualTimeRequest: {
      type: Boolean,
      default: false,
    },
    timeEntryExtendedByManualTimeRequestWarning: {
      type: String,
      default: '',
    },
    isNew: {
      type: Boolean,
      default: true,
    },
    editingWithoutCollisionsMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['projectFlavour']),
    collisionTooltip() {
      const label = getTaskFlavourLabel(this.projectFlavour);

      return `No ${label.toLowerCase()} present`;
    },
    notAccessibleExists() {
      return !this.notAccessibleIsEmpty;
    },
    notAccessibleIsEmpty() {
      return isEmpty(this.check.not_accessible);
    },
    collisionsExists() {
      return !this.collisionsIsEmpty;
    },
    collisionsIsEmpty() {
      return isEmpty(this.check.collisions);
    },
    editingWithoutCollisions() {
      return !this.isNew && this.collisionsIsEmpty && this.editingWithoutCollisionsMessage;
    },
    collisionWarningMessage() {
      if (this.isWorkBreak) {
        return 'This work break overlaps with another time entry and cannot be saved:';
      }
      if (this.check.immutable) {
        return 'This time entry overlaps with a locked time entry and cannot be saved:';
      }
      if (this.notAccessibleExists && this.collisionsIsEmpty) {
        return 'There is overlap with time entries which you don’t have access to:';
      }
      if (this.collisionsExists && this.timeEntryExtendedByManualTimeRequestWarning !== '') {
        return this.timeEntryExtendedByManualTimeRequestWarning;
      }
      if (this.collisionsExists && !this.check.immutable && this.notAccessibleIsEmpty && !this.isManualTimeRequest) {
        return 'This time entry overlaps with others, which will be replaced:';
      }
      if (this.collisionsExists && !this.check.immutable && this.notAccessibleIsEmpty && this.isManualTimeRequest) {
        return 'This time entry overlaps with other time entries already submitted. To submit another entry, change the time span.';
      }
      if (this.collisionsExists && !this.check.immutable && this.notAccessibleExists) {
        return 'This time entry overlaps with others, some of which you don’t have access to:';
      }

      return '';
    },
  },
  methods: {
    collisionText(collision) {
      return collision.task_summary
        ? `${collision.project_name} / ${collision.task_summary} `
        : `${collision.project_name} `;
    },
    formatDuration(duration) {
      return TimeUtils.format_duration(duration);
    },
  },
};
</script>
